// extracted by mini-css-extract-plugin
module.exports = {"p":"ContactTabs_p__JHq3F","textContainer":"ContactTabs_textContainer__JAxU3","contactText":"ContactTabs_contactText__9LT_3","mabPhone":"ContactTabs_mabPhone__t5Hpw"};